module.exports = window.moment;